import React from "react";
import A2WhyCard from "../../A2Page/A2Why/A2WhyCard";
import "./../../A2Page/A2Page.css"
import instructor from "./../../../Media/instructor.png";

const B1WhyMain = () => {
  return (
    <div className="a2WhyMainContainer">
      <A2WhyCard
        img={instructor}
        head="Expert Instructors"
        para="Our B1 German Classes in Bangalore are taught by highly experienced and certified instructors who are passionate about teaching. They bring a wealth of knowledge and real-world experience to the classroom, making learning both effective and enjoyable. With their guidance, you’ll navigate through complex grammatical structures and expand your vocabulary significantly."
      />
      <A2WhyCard
        img={instructor}
        head="Comprehensive Curriculum"
        para="The curriculum of our B1 German Classes in Bangalore is meticulously designed to cover all aspects of the language. You’ll delve deeper into advanced grammar, improve your speaking and writing skills, and enhance your listening and reading comprehension. Our curriculum is aligned with the Common European Framework of Reference for Languages (CEFR), ensuring you’re well-prepared for the B1 certification exam."
      />
      <A2WhyCard
        img={instructor}
        head="Interactive Learning Environment"
        para="We believe that active participation is key to mastering a language. Our B1 German Classes in Bangalore incorporate a variety of interactive activities such as group discussions, role-plays, and language games. These activities not only make learning fun but also help you practice speaking and listening in real-life scenarios, boosting your confidence."
      />
      <A2WhyCard
        img={instructor}
        head="Flexible Learning Options"
        para="At Prizma Academy, we offer both online and offline B1 German Classes in Bangalore to cater to your preferences and schedule. Our online classes are designed to be as interactive and effective as our in-person sessions, providing you with the flexibility to learn from anywhere. Whether you prefer the convenience of online learning or the traditional classroom experience, we’ve got you covered."
      />
      <A2WhyCard
        img={instructor}
        head="Cultural Immersion"
        para="Understanding the culture behind the language is crucial for effective communication. Our B1 German Classes in Bangalore include cultural immersion elements that give you insights into German traditions, customs, and societal norms. This cultural awareness enhances your language skills and prepares you for real-world interactions with German speakers. "
      />
      <A2WhyCard
        img={instructor}
        head="Personalized Attention"
        para="We recognize that every student learns at their own pace and has unique needs. Our B1 German Classes in Bangalore have small class sizes to ensure personalized attention from instructors. You’ll receive regular feedback on your progress and tailored support to address your specific challenges, helping you achieve your language goals faster."
      />
      <A2WhyCard
        img={instructor}
        head="Preparation for Certification"
        para="If you’re aiming to obtain a B1 certification, our B1 German Classes in Bangalore are the perfect preparation. We provide comprehensive training that includes practice tests, exam strategies, and focused sessions on the skills required for the B1 exam. With our guidance, you’ll be well-prepared to take and pass the certification exam with confidence."
      />
      <A2WhyCard
        img={instructor}
        head="Real-World Applications"
        para="Our B1 German Classes in Bangalore emphasize practical usage of the language. You’ll engage in conversations, write essays, and read articles on various topics to apply your language skills in real-world contexts. This practical approach ensures you’re not only learning the language but also able to use it effectively in everyday situations."
      />
      <A2WhyCard
        img={instructor}
        head="Success Stories"
        para="Success Stories The success of our students speaks volumes about the quality of our B1 German Classes in Bangalore. Many of our alumni have achieved their academic and professional goals, thanks to the strong language foundation they built at Prizma Academy. Whether it’s securing a job in a German-speaking country, pursuing higher education in Germany, or simply enjoying travel and cultural experiences, our students have benefited immensely from their language skills."
      />
    </div>
  );
};

export default B1WhyMain;
